import React from 'react';
import { Phone, ShieldCheck, Clock } from 'lucide-react';
export function UtilityBar() {
  return <div className="bg-navy-900 text-white py-2 px-4 text-xs sm:text-sm font-medium border-b border-white/10 relative z-50" data-id="element-482">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2" data-id="element-483">
        <div className="flex items-center gap-4 sm:gap-6" data-id="element-484">
          <div className="flex items-center gap-1.5 text-gray-300" data-id="element-485">
            <Clock className="w-3.5 h-3.5 text-accent" data-id="element-486" />
            <span className="hidden sm:inline" data-id="element-487">
              After-hours emergency: 0418 381 988
            </span>
            <span className="sm:hidden" data-id="element-488">After-hours emergency</span>
          </div>
          <div className="hidden md:flex items-center gap-1.5 text-gray-300" data-id="element-489">
            <ShieldCheck className="w-3.5 h-3.5 text-accent" data-id="element-490" />
            Fully Licensed · ABN 40 434 878 561
          </div>
        </div>
        <a href="tel:0418381988" className="flex items-center gap-1.5 font-bold hover:text-accent transition-colors" data-id="element-491">
          <Phone className="w-3.5 h-3.5 text-accent" data-id="element-492" />
          0418 381 988
        </a>
      </div>
    </div>;
}